export default __webpack_public_path__ + "static/media/sorekt Light Mode.4357474b.png";